import { axiosClient } from '@nx-frontend/shared/api';
import { BillingAddon, GetIsAddonWasPurshasedEarlyProps } from '@nx-frontend/shared/types';
import { BillingPlanResponse } from '@nx-frontend/shared/types/paywall-types';

export async function getIsAddonWasPurshasedEarly({
  gatewayUrl,
  subscriptionId,
  addon,
  sessionId,
  currentSubscriptionCode,
}: GetIsAddonWasPurshasedEarlyProps) {
  if (!subscriptionId || !sessionId) {
    return false;
  }
  return await (async function () {
    try {
      const purshasedAddon = (
        await axiosClient.get<BillingAddon>(
          `${gatewayUrl}/ft:billing/subscriptions/${subscriptionId}/addons/${addon}`,
          {
            headers: {
              'everhelper-session-id': sessionId,
            },
          }
        )
      ).data;
      if (purshasedAddon && currentSubscriptionCode) {
        const { plans } = (
          await axiosClient.get<BillingPlanResponse>(`${gatewayUrl}/ft:billing/plans`, {
            headers: {
              'everhelper-session-id': sessionId,
            },
          })
        ).data;
        const plan = plans.find((plan) => plan.code === currentSubscriptionCode);
        if (plan) {
          const { defaultAddons } = plan;
          const defaultAddon = defaultAddons.find((a) => a.code === addon);
          if (defaultAddon) {
            const purshasedQuantity = purshasedAddon.quantity ?? 0;
            if (purshasedQuantity <= (defaultAddon.quantity ?? 0)) {
              return false;
            }
          }
        }
      }
      return true;
    } catch (err) {
      return false;
    }
  })();
}
